/* eslint-disable max-lines-per-function */
import "./ArtworkHistoryArtworksToggle.scss";
import { cn } from "tailwind-variants";

export default function ArtworkHistoryArtworksToggle({
  disabled,
  type,
  onUpdateType,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={cn("artwork-history-artworks-toggle scope-06330f48", restProps.className)}
    >
      <button
        className={cn("artwork-history-artworks-toggle__button scope-06330f48", {
          "artwork-history-artworks-toggle__button--active": type === "uploaded"
        })}
        type="button"
        disabled={disabled}
        onClick={() => {
          onUpdateType("uploaded");
        }}
        data-testid="artwork-history-artworks-toggle-button"
      >
        {" "}
        Uploaded{" "}
      </button>
      <button
        className={cn("artwork-history-artworks-toggle__button scope-06330f48", {
          "artwork-history-artworks-toggle__button--active": type === "purchased"
        })}
        type="button"
        disabled={disabled}
        onClick={() => {
          onUpdateType("purchased");
        }}
        data-testid="artwork-history-artworks-toggle-button-1"
      >
        {" "}
        Purchased{" "}
      </button>
    </div>
  );
}
